import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { ExportCSVReport } from 'utils/createCSVReportFile';
import { downloadURI } from 'utils/downloadDataURI';

import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { catalogUEROtherCostTemplateForUpdateGql } from '../catalogUerOtherCostTemplatesQueries';

const asyncDownloadURI = async (dataUrl: string, name: string) => {
    await downloadURI(dataUrl, name);
};

export const useDownloadOtherCostTemplate = (otherCostTemplateId: number) => {
    const dispatch = useDispatch();

    const [isSubmittedDownload, setIsSubmittedDownload] = useState<boolean>(false);

    const [
        downloadOtherCostTemplateData,
        downloadOtherCostTemplateStatus,
        downloadOtherCostTemplateError,
        downloadOtherCostTemplateRequest,
        downloadOtherCostTemplateSetData,
        downloadOtherCostTemplateAbort,
    ] = useRequest({
        requestId: `downloadOtherCostTemplate`,
        query: catalogUEROtherCostTemplateForUpdateGql,
        withEffect: false,
    });

    useEffect(() => {
        if (
            isSubmittedDownload &&
            downloadOtherCostTemplateStatus === RequestStatus.SUCCESS &&
            downloadOtherCostTemplateData?.catalogUEROtherCostTemplate?.result
        ) {
            const { file } = downloadOtherCostTemplateData?.catalogUEROtherCostTemplate.data || {};

            if (file) {
                asyncDownloadURI(file.dataUrl, file.name);
                dispatch(downloadOtherCostTemplateSetData(undefined));
                setIsSubmittedDownload(false);
            }
        }
    }, [
        dispatch,
        downloadOtherCostTemplateData?.catalogUEROtherCostTemplate.data,
        downloadOtherCostTemplateData?.catalogUEROtherCostTemplate?.result,
        downloadOtherCostTemplateSetData,
        downloadOtherCostTemplateStatus,
        isSubmittedDownload,
    ]);

    const onDownloadOtherCostTemplate = useCallback(
        (id: number) => {
            dispatch(downloadOtherCostTemplateRequest({ id }));
            setIsSubmittedDownload(true);
        },
        [dispatch, downloadOtherCostTemplateRequest],
    );

    const onCloseModalErrorDownload = useCallback(() => {
        setIsSubmittedDownload(false);
    }, []);

    const onCreateReportDownload = useCallback(() => {
        ExportCSVReport(downloadOtherCostTemplateData?.catalogUEROtherCostTemplate?.validation);
    }, [downloadOtherCostTemplateData?.catalogUEROtherCostTemplate?.validation]);

    const onOtherCostTemplateAbort = useCallback(() => {
        dispatch(downloadOtherCostTemplateAbort());
        setIsSubmittedDownload(false);
    }, [dispatch, downloadOtherCostTemplateAbort]);

    return {
        isSubmittedDownload,
        downloadOtherCostTemplateData,
        downloadOtherCostTemplateStatus,
        downloadOtherCostTemplateError,
        onOtherCostTemplateAbort,
        onDownloadOtherCostTemplate,
        onCloseModalErrorDownload,
        onCreateReportDownload,
    };
};
